import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<section id=\"home\" class=\"h40 d-flex align-items-center bg-contact section-padding mt-5 mt-md-0\"><div class=\"container\"><div class=\"row justify-content-center text-center\"><div class=\"col-sm-12 col-lg-8\"><h1 class=\"title text-shadow\">Contacto</h1></div></div></div></section>", 1)
const _hoisted_2 = {
  id: "work",
  class: "py-5 align-items-center"
}
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "row justify-content-center" }
const _hoisted_5 = { class: "col col-lg-5 mb-5 text-justify" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, " Por favor déjanos cualquier duda, queja o aclaración, y un agente se pondrá en contacto contigo en menos de 24 horas. ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_8 = { class: "p-field" }
const _hoisted_9 = { class: "p-float-label p-input-icon-right" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-user pr-1" }, null, -1)
const _hoisted_11 = {
  key: 0,
  class: "p-error pl-2"
}
const _hoisted_12 = { class: "p-field" }
const _hoisted_13 = { class: "p-float-label p-input-icon-right" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-envelope pr-1" }, null, -1)
const _hoisted_15 = { key: 0 }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("small", { class: "p-error pl-2" }, "Ingresa un correo válido.", -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = {
  key: 1,
  class: "p-error pl-2"
}
const _hoisted_19 = { class: "p-field" }
const _hoisted_20 = { class: "p-float-label p-input-icon-right" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-phone pr-1" }, null, -1)
const _hoisted_22 = { key: 0 }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("small", { class: "p-error pl-2" }, "Ingresa un teléfono válido.", -1)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = {
  key: 1,
  class: "p-error pl-2"
}
const _hoisted_26 = { class: "p-field" }
const _hoisted_27 = { class: "p-float-label p-input-icon-right" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-comment pr-1" }, null, -1)
const _hoisted_29 = {
  key: 0,
  class: "p-error pl-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_InputMask = _resolveComponent("InputMask")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _hoisted_7,
            _createElementVNode("form", {
              name: "form",
              onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.sendEmail(!_ctx.v$.$invalid)), ["prevent"])),
              class: "pt-2"
            }, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createVNode(_component_InputText, {
                    type: "text",
                    id: "name",
                    modelValue: _ctx.v$.name.$model,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.v$.name.$model) = $event)),
                    class: _normalizeClass({ 'p-invalid': _ctx.v$.name.$invalid && _ctx.submitted }),
                    "aria-describedby": "name-error"
                  }, null, 8, ["modelValue", "class"]),
                  _createElementVNode("label", {
                    for: "name",
                    class: _normalizeClass(["pl-2", { 'p-error': _ctx.v$.name.$invalid && _ctx.submitted }])
                  }, "Nombre completo", 2)
                ]),
                (
                    (_ctx.v$.name.$invalid && _ctx.submitted) ||
                      _ctx.v$.name.$pending.$response
                  )
                  ? (_openBlock(), _createElementBlock("small", _hoisted_11, "Este campo es obligatorio."))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createVNode(_component_InputText, {
                    id: "email",
                    modelValue: _ctx.v$.email.$model,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.v$.email.$model) = $event)),
                    class: _normalizeClass({ 'p-invalid': _ctx.v$.email.$invalid && _ctx.submitted }),
                    "aria-describedby": "email-error"
                  }, null, 8, ["modelValue", "class"]),
                  _createElementVNode("label", {
                    for: "email",
                    class: _normalizeClass(["pl-2", { 'p-error': _ctx.v$.email.$invalid && _ctx.submitted }])
                  }, "Correo electrónico", 2)
                ]),
                (_ctx.v$.email.$invalid && _ctx.submitted)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_15, _hoisted_17))
                  : (
                    (_ctx.v$.email.$invalid && _ctx.submitted) ||
                      _ctx.v$.email.$pending.$response
                  )
                    ? (_openBlock(), _createElementBlock("small", _hoisted_18, "Este campo es obligatorio."))
                    : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _hoisted_21,
                  _createVNode(_component_InputMask, {
                    modelValue: _ctx.v$.phone.$model,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.v$.phone.$model) = $event)),
                    mask: "9999999999",
                    class: _normalizeClass({ 'p-invalid': _ctx.v$.phone.$invalid && _ctx.submitted }),
                    "aria-describedby": "phone-error",
                    autoClear: false
                  }, null, 8, ["modelValue", "class"]),
                  _createElementVNode("label", {
                    for: "phone",
                    class: _normalizeClass(["pl-2", { 'p-error': _ctx.v$.phone.$invalid && _ctx.submitted }])
                  }, "Teléfono", 2)
                ]),
                (_ctx.v$.phone.$invalid && _ctx.submitted)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_22, _hoisted_24))
                  : (
                    (_ctx.v$.phone.$invalid && _ctx.submitted) ||
                      _ctx.v$.phone.$pending.$response
                  )
                    ? (_openBlock(), _createElementBlock("small", _hoisted_25, "Este campo es obligatorio."))
                    : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _hoisted_28,
                  _createVNode(_component_Textarea, {
                    id: "message",
                    modelValue: _ctx.v$.message.$model,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.v$.message.$model) = $event)),
                    rows: "2",
                    class: _normalizeClass({ 'p-invalid': _ctx.v$.message.$invalid && _ctx.submitted }),
                    "aria-describedby": "message-error",
                    autoResize: true
                  }, null, 8, ["modelValue", "class"]),
                  _createElementVNode("label", {
                    for: "message",
                    class: _normalizeClass(["pl-2", { 'p-error': _ctx.v$.message.$invalid && _ctx.submitted }])
                  }, "Escribe tu mensaje aquí", 2)
                ]),
                (
                    (_ctx.v$.message.$invalid && _ctx.submitted) ||
                      _ctx.v$.message.$pending.$response
                  )
                  ? (_openBlock(), _createElementBlock("small", _hoisted_29, "Este campo es obligatorio."))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_component_Button, {
                type: "submit",
                label: "Enviar",
                class: "p-button-raised p-button-rounded",
                loading: _ctx.loading
              }, null, 8, ["loading"])
            ], 32)
          ])
        ])
      ])
    ])
  ]))
}